import * as Types from '../../types';

import { gql } from '@apollo/client';
import { EntityRiskIndicatorFragmentDoc } from '../RiskIndicator/RiskIndicator.generated';
export type EntityDisplayFragment = {
  __typename?: 'Entity';
  id: any;
  name: string;
  risks: {
    __typename?: 'EntityRiskConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'EntityRiskEdge';
      node: {
        __typename?: 'EntityRisk';
        id: any;
        riskType: string;
        severity: string;
        description?: string | null;
      };
    }>;
  };
};

export const EntityDisplayFragmentDoc = gql`
  fragment EntityDisplay on Entity {
    id
    name
    risks {
      ...EntityRiskIndicator
    }
  }
  ${EntityRiskIndicatorFragmentDoc}
`;
